/**
 * True when the portal must not offer ACH (deposit invoices; or API explicitly allows card only).
 */
export function isCardOnlyCheckout(invoice: any): boolean {
  if (!invoice) return false
  if (invoice.invoiceType === 'deposit') return true
  const allowed = invoice.allowedPaymentMethods as string[] | undefined
  return Array.isArray(allowed) && allowed.length === 1 && allowed[0] === 'card'
}

/**
 * Shared rules for public invoice PDF / pay-select flows.
 * Deposit invoices carry full project totals on the invoice row; checkout uses amountDueForCheckout (deposit).
 */
export function getPublicInvoicePayContext(invoice: any): {
  totalAmount: number
  paidAmount: number
  balanceAmount: number
  isDepositInvoice: boolean
  payAmount: number
  isPaid: boolean
} {
  const totalAmount = Number(invoice?.totalAmount) || 0
  const paidAmount = Number(invoice?.paidAmount) || 0
  const balanceAmount = Number(invoice?.balanceAmount) || (totalAmount - paidAmount)
  const isDepositInvoice = invoice?.invoiceType === 'deposit'
  const rawBalance = balanceAmount
  const amountDueForCheckout =
    invoice?.amountDueForCheckout != null && invoice?.amountDueForCheckout !== ''
      ? Number(invoice.amountDueForCheckout)
      : rawBalance
  const payAmount = Number.isFinite(amountDueForCheckout) ? amountDueForCheckout : rawBalance
  const isPaid =
    invoice?.status === 'paid' ||
    invoice?.paidAt != null ||
    (!isDepositInvoice && rawBalance <= 0)

  return {
    totalAmount,
    paidAmount,
    balanceAmount,
    isDepositInvoice,
    payAmount,
    isPaid
  }
}
